// Trial-signup Meta event. Fires `StartTrial` (Meta Standard Event) when
// the /post-purchase route loader resolves `trialStarted: true` —
// sourced server-side from `subscription.status === 'trialing'`, NOT
// from the frontend `useFreeTrialAvailable()` config flag (see
// audit-cookie-trackers.md Phase R2 follow-up for the decision log).
//
// Assumes `fbq` was already initialized by the site-wide
// `meta-pixel.js`, which fires on every marketing route + on
// /post-purchase.
//
// `value: 0` is correct — no money has changed hands at trial start,
// even though the eventual subscription `unit_amount` is already set to
// the post-trial charge (which varies by pricing arm).
//
// `currency` still comes from the loader: the backend reads it off the
// price regardless of subscription status, so it is known here even
// though the amount is deliberately zero.
//
// Coverage gap (tracked in audit-cookie-trackers.md): Meta and Google
// Ads (`google-ads-start-trial.ts`) fire on trial start; the other
// purchase-stage platforms (Reddit, TikTok, Quora, Podscribe, Twitter)
// have no trial event wired.
export function metaPixelStartTrialScript(currency: string): string {
  return `
/* eslint-disable -- inline pixel script, vendor-shaped js */
fbq('track', 'StartTrial', { value: 0.0, currency: '${currency}' });
`;
}
